/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { _ as __assign } from '../../tslib.es6-e01eabb2.js';
import { K as index$1 } from '../../index-e5fa4dec.js';
import '../../index-6f6b9acc.js';
import { i as isString, a as isArray } from '../../is-7fc17687.js';
import { extend } from '../extend/index.js';
import previewImage$2 from './cn/index.js';
import previewImage$1 from './dingTalk/index.js';
import mini from './mini/index.js';
import '../../_commonjsHelpers-56d33373.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';
import '../../index-0bcce539.js';

var apiConfig = {
    web: {
        dingTalk: previewImage$1,
        windvane: {
            cn: previewImage$2,
            cnStation: previewImage$2,
        },
    },
    // @ts-ignore TODO TS类型处理，mini容器暂时不改动之前的逻辑
    mini: mini,
};
var extendPreviewImage = extend(apiConfig, index$1);
/**
 * 预览图片
 * @param  {!string | string[] | PreviewImageIOptions} urls 预览的图片地址
 * @param  {?PreviewImageIOptions} params 当第一个参数为string 或 string[]格式时，此参数有效。
 * @returns {Promise<unknown>} promise调用结果

 * @example 使用案例：
 * import { previewImage } from '@alife/cn-uni-api';
 *
 *  previewImage('https://gw.alicdn.com/imgextra/i4/O1CN01tmIVdW22WftYPPH1O_!!6000000007128-2-tps-135-133.png'）
 *  .then(() => {
 *    console.log('success');
 *  })
 *  .catch((error) => {
 *    console.log(error);
 *  });
 * @author 敬文
 */
var previewImage = function (urls, params) {
    if (isString(urls)) {
        return extendPreviewImage(__assign(__assign({}, params), { urls: [urls] }));
    }
    if (isArray(urls)) {
        return extendPreviewImage(__assign(__assign({}, params), { urls: urls }));
    }
    return extendPreviewImage(urls);
};

export { previewImage };
